import { SharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BidsRoutingModule } from './bids-routing.module';
import { ListingComponent } from './pages/listing/listing.component';


@NgModule({
  declarations: [
    ListingComponent
  ],
  imports: [
    CommonModule,
    BidsRoutingModule,
    SharedModule
  ]
})
export class BidsModule { }
